module.exports = __webpack_public_path__ + "img/effect.93eeed96.png";